(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("xes-frontend-ui/lib/mixins/styleMixin"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "xes-frontend-ui/lib/mixins/styleMixin"], factory);
	else if(typeof exports === 'object')
		exports["VueDropUpload"] = factory(require("vue"), require("xes-frontend-ui/lib/mixins/styleMixin"));
	else
		root["VueDropUpload"] = factory(root["Vue"], root["xes-frontend-ui/lib/mixins/styleMixin"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_68__, __WEBPACK_EXTERNAL_MODULE_96__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition